import { BrandedIcon, BrandedIconName, Icon } from '@volvo-cars/react-icons';
import { useEffect, useState } from 'react';

import { Tooltip } from '@collab/atoms';
import useCopy from '@collab/hooks/useCopy';

type SocialLinkProps = {
  title: string;
  icon: BrandedIconName;
  sharerUrl: string;
};

const socialLinks: SocialLinkProps[] = [
  {
    title: 'LinkedIn',
    icon: 'linkedin',
    sharerUrl: 'https://www.linkedin.com/shareArticle?url=',
  },
  {
    title: 'Facebook',
    icon: 'facebook',
    sharerUrl: 'https://www.facebook.com/sharer/sharer.php?u=',
  },
  {
    title: 'X',
    icon: 'x-app',
    sharerUrl: 'https://twitter.com/intent/tweet?text=',
  },
];

const Share: React.FC = () => {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <div className="flex-col md:flex-row items-center justify-between pb-8 border-b">
      <p className="font-medium mb-16 md:mb-0 text-secondary">Share</p>
      <div className="flex gap-16">
        {url && (
          <>
            {socialLinks.map((p) => (
              <SocialIcon key={p.title} socialLink={p} url={url} />
            ))}
            <CopyIcon url={url} />
          </>
        )}
      </div>
    </div>
  );
};

const SocialIcon: React.FC<{
  socialLink: SocialLinkProps;
  url: string;
}> = ({ socialLink: { title, icon, sharerUrl }, url }) => (
  <a
    href={sharerUrl + url}
    target="_blank"
    title={title}
    aria-label={title}
    rel="noreferrer"
  >
    <BrandedIcon alt={title} icon={icon} size={24} />
  </a>
);

const CopyIcon: React.FC<{ url: string }> = ({ url }) => {
  const { copied, onCopy } = useCopy();

  return (
    <Tooltip text="Copied to clipboard" visible={copied} placement="top">
      <button
        onClick={() => onCopy(url)}
        aria-label="Copy to clipboard"
        title="Copy to clipboard"
        type="button"
      >
        <Icon alt="copy" icon="link" size={24} filled />
      </button>
    </Tooltip>
  );
};

export default Share;
